import axios from '../../utils/axios-wrapper';
import { API_ORIGIN, WWW_ORIGIN } from '../../config';

export default {
  postUserData(userId, payload) {
    return fetch(`${API_ORIGIN}/v2/users/${userId}/update-user-info`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        Cookie: document.cookie,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
  },

  getUser(userId) {
    return axios.get(`${API_ORIGIN}/v2/users/${userId}`);
  },

  postAddShipping(userId, payload) {
    return axios.post(
      `${API_ORIGIN}/v2/users/${userId}/add-shipping-address`,
      payload
    );
  },

  postUpdateShipping(userId, payload) {
    return axios.post(
      `${API_ORIGIN}/v2/users/${userId}/update-shipping-address`,
      payload
    );
  },

  postRemoveShipping(userId, payload) {
    return axios.post(
      `${API_ORIGIN}/v2/users/${userId}/remove-shipping-address`,
      payload
    );
  },

  postBillingEmailAddress(userId, payload) {
    return axios.patch(
      `${API_ORIGIN}/v2/users/${userId}/update-billing-email-address`,
      payload
    );
  },

  postUserTaxExempt(userId, payload) {
    return axios.post(
      `${API_ORIGIN}/v2/users/${userId}/update-tax-exemption`,
      payload
    );
  },

  postUserThirdPartyApprovedShipping(userId, payload) {
    return axios.post(
      `${API_ORIGIN}/v2/users/${userId}/update-3rd-party-shipping`,
      payload
    );
  },

  postAddShippingAccount(userId, payload) {
    return axios.post(
      `${API_ORIGIN}/v2/users/${userId}/add-shipping-account`,
      payload
    );
  },

  postRemoveShippingAccount(userId, payload) {
    return axios.post(
      `${API_ORIGIN}/v2/users/${userId}/remove-shipping-account`,
      payload
    );
  },

  postValidateCurrentPassword(userId, payload) {
    return axios.post(
      `${API_ORIGIN}/v2/users/${userId}/validate-current-password`,
      payload
    );
  },

  postAwardCredits(userId, payload) {
    return axios.post(
      `${API_ORIGIN}/v2/users/${userId}/award-credits`,
      payload
    );
  },

  postMfaMethod(userId, payload) {
    return axios.post(
      `${API_ORIGIN}/v2/users/${userId}/add-mfa-method`,
      payload
    );
  },

  deleteMfaMethod(userId) {
    return axios.post(`${API_ORIGIN}/v2/users/${userId}/remove-mfa-method`);
  },

  postRequirementsInfo(payload) {
    return axios.post(
      `${WWW_ORIGIN}/api/requirements-service/2/requirements?withResult=display`,
      payload
    );
  },

  postPatchRequirementsInfo(payload) {
    return axios.post(
      `${WWW_ORIGIN}/api/requirements-service/2/patch`,
      payload
    );
  },
};
